import VueRouter from 'vue-router'
import Home from "../components/Home";
import PeripheralDetail from "../components/PeripheralDetail"
import CharacteristicDetail from "../components/CharacteristicDetail"

const routes = [
    {path: '/home', component: Home, name: 'Home'},
    {path: '/deviceDetail', component: PeripheralDetail, name: 'PeripheralDetail'},
    {path: '/characteristicDetail', component: CharacteristicDetail, name: 'CharacteristicDetail'}
];
const router = new VueRouter({
    routes
});
router.beforeEach((to, from, next) => {
    if(to.path === `/`) next(`/home`);
    else next();
});
export default router